<template>
  <task-index typeTitle="水样对比"></task-index>
</template>

<script>
import taskIndex from '../components/taskIndex.vue';
export default {
  components: {
    taskIndex
  }
}
</script>
